"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var acorn = require("acorn");
var kiwi = require("kiwi.js");
var kiwifruit_core_1 = require("kiwifruit-core");
function parseConstraint(toParse, replacer) {
    var program = acornParseCached(toParse);
    return programToConstraint(program, replacer);
}
exports.parseConstraint = parseConstraint;
function parseExpression(toParse, replacer) {
    var program = acornParseCached(toParse);
    return programToExpression(program, replacer);
}
exports.parseExpression = parseExpression;
function programToConstraint(node, replacer) {
    var expressionStatement = node.body[0];
    if (!expressionStatement || expressionStatement.type !== "ExpressionStatement") {
        throw new Error("A constraint needs a top-level operator: ==, >=, or <=.");
    }
    var binaryExpression = expressionStatement.expression;
    if (binaryExpression.type !== "BinaryExpression") {
        throw new Error("A constraint needs a top-level operator: ==, >=, or <=.");
    }
    var kiwiOperator = { "==": kiwi.Operator.Eq, ">=": kiwi.Operator.Ge, "<=": kiwi.Operator.Le }[binaryExpression.operator];
    if (kiwiOperator === undefined) {
        throw new Error("The top-level operator must be ==, >=, or <=; " + binaryExpression.operator + " is not allowed.");
    }
    var left = nodeToExpression(binaryExpression.left, replacer);
    var right = nodeToExpression(binaryExpression.right, replacer);
    var diff = kiwifruit_core_1.Expression.minus(left, right);
    return {
        expression: diff,
        operator: kiwiOperator,
        strength: kiwi.Strength.medium,
    };
}
function programToExpression(node, replacer) {
    var expressionStatement = node.body[0];
    if (!expressionStatement || expressionStatement.type !== "ExpressionStatement") {
        throw new Error("An expression needs a top-level expression.");
    }
    return nodeToExpression(expressionStatement.expression, replacer);
}
function nodeToExpression(node, replacer) {
    if (replacer) {
        var replacement = replacer(node);
        if (replacement) {
            return replacement;
        }
    }
    if (node.type === 'Literal') {
        if (typeof node.value === 'number') {
            return kiwifruit_core_1.Expression.constant(node.value);
        }
        else {
            throw new Error("The value '" + node.raw + "' cannot be used.");
        }
    }
    if (node.type === 'Identifier') {
        return kiwifruit_core_1.Expression.variable(node.name);
    }
    if (node.type === 'BinaryExpression') {
        var left = nodeToExpression(node.left, replacer);
        var right = nodeToExpression(node.right, replacer);
        if (node.operator === '+') {
            return kiwifruit_core_1.Expression.plus(left, right);
        }
        else if (node.operator === '-') {
            return kiwifruit_core_1.Expression.minus(left, right);
        }
        else if (node.operator === '*') {
            return kiwifruit_core_1.Expression.times(left, right);
        }
        else if (node.operator === '/') {
            return kiwifruit_core_1.Expression.divide(left, right);
        }
        throw new Error("The operator " + node.operator + " cannot be used.");
    }
    if (node.type === 'UnaryExpression') {
        var argument = nodeToExpression(node.argument, replacer);
        if (node.operator === '-') {
            return kiwifruit_core_1.Expression.timesNum(argument, -1);
        }
        throw new Error("The operator " + node.operator + " cannot be used.");
    }
    throw new Error("This construction cannot be used: " + node.type + ".");
}
function parseConstraintTemplate(templateStrings) {
    var interpolations = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        interpolations[_i - 1] = arguments[_i];
    }
    var toParse = interpolationJoinTemplateStrings(templateStrings);
    return parseConstraint(toParse, interpolationNodeReplacer(interpolations));
}
exports.parseConstraintTemplate = parseConstraintTemplate;
function parseExpressionTemplate(templateStrings) {
    var interpolations = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        interpolations[_i - 1] = arguments[_i];
    }
    var toParse = interpolationJoinTemplateStrings(templateStrings);
    return parseExpression(toParse, interpolationNodeReplacer(interpolations));
}
exports.parseExpressionTemplate = parseExpressionTemplate;
function interpolationJoinTemplateStrings(templateStrings) {
    var toParseBits = [];
    templateStrings.forEach(function (templateString, i) {
        toParseBits.push(templateString);
        if (i < templateStrings.length - 1) {
            toParseBits.push("interpolation[" + i + "]");
        }
    });
    return toParseBits.join('');
}
function interpolationNodeReplacer(interpolations) {
    return function (node) {
        if (node.type === 'MemberExpression' &&
            node.object.type === 'Identifier' && node.object.name === 'interpolation' &&
            node.property.type === 'Literal' && typeof node.property.value === 'number') {
            return kiwifruit_core_1.Expression.from(interpolations[node.property.value]);
        }
        return undefined;
    };
}
var acornParseCache = {};
function acornParseCached(toParse) {
    var cachedProgram = acornParseCache[toParse];
    if (cachedProgram) {
        return cachedProgram;
    }
    var computedProgram = acorn.parse(toParse); // TODO: different typings for acorn?
    acornParseCache[toParse] = computedProgram;
    return computedProgram;
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../kiwifruit/kiwifruit-parse/build/index.js
// module id = 86
// module chunks = 0